export default {

    computed:{
        innerValue: {
            get(){
                return this.value
            },
            set(value){
                this.updateValue(value)
            }
        }
    },

    props: {
        token: {
            type: Object,
            required:true
        },
        value: {
            default: null
        }
    },

    methods: {
        updateValue(value){
            this.$emit('input',value)
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/formElement.js